module.exports = __webpack_public_path__ + "static/img/fast-lube-logo.d429728.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fast-lube-logo.png
// module id = GCSg
// module chunks = 1